import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";
import DashboardDoughnut from "../DashboardDoughnut";
import DoughnutLegend from "../DoughnutLegend";
import DashboardBar from "../DashboardBar";

import { calculatePercentage } from "../../../utils/data";

import { sizes } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const styles = {
  doughnutContainer: {
    margin: "0px 20px",
    display: "flex",
    alignItems: "center",
  },
};

const MdcAutomationEfficiency = (props) => {
  const { classes, data } = props;

  const doughnutColors = [colors.dashboardDarkBlue, colors.dashboardLightBlue];

  if (!get(data, ["card6", "assistance_required", "total"])) {
    return null;
  }

  return (
    <DashboardCard
      title={I18n.get("dashboard_automationEfficiency")}
      size={sizes.medium}
      style={{
        margin: "12px",
        minWidth: "625px",
        flexGrow: 1,
      }}
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100%" }}
      >
        <Grid item className={classes.doughnutContainer}>
          <DashboardDoughnut
            title={I18n.get("dashboard_entrancesExits")}
            values={[
              get(data, ["card6", "ia", "total"]),
              get(data, ["card6", "assistance_required", "total"]),
            ]}
            total={
              get(data, ["card6", "ia", "total"]) +
              get(data, ["card6", "assistance_required", "total"])
            }
            colors={doughnutColors}
          />
        </Grid>
        <Grid
          item
          style={{
            marginLeft: "10px",
            padding: "0px 0px 0px 14px",
            minWidth: "160px",
            marginRight: "-1px",
          }}
        >
          <Grid container direction="column">
            <Grid
              item
              style={{
                padding: "8px 8px",
              }}
            >
              <Grid container direction="column">
                <DoughnutLegend
                  color={doughnutColors[0]}
                  title={I18n.get("dashboard_entryExitAi")}
                  value={get(data, ["card6", "ia", "total"])}
                  percentage={calculatePercentage(
                    get(data, ["card6", "ia", "percentage"]),
                    1
                  )}
                />
              </Grid>
            </Grid>
            <Grid
              item
              style={{
                border: `1px solid ${colors.veryLighPink}`,
                borderRight: "none",
                borderRadius: "4px",
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
                padding: "8px 8px",
                zIndex: 200,
                backgroundColor: colors.white,
              }}
            >
              <Grid container direction="column">
                <DoughnutLegend
                  color={doughnutColors[1]}
                  title={I18n.get("dashboard_assistanceRequired")}
                  value={get(data, ["card6", "assistance_required", "total"])}
                  percentage={calculatePercentage(
                    get(data, ["card6", "assistance_required", "percentage"]),
                    1
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs style={{ marginTop: "-25px" }}>
          <Grid container direction="column">
            <Grid item className="text-54" style={{ fontSize: "0.857em" }}>
              {I18n.get("dashboard_assistanceTopReasons")}
            </Grid>
            <Grid
              item
              style={{
                border: `1px solid ${colors.veryLighPink}`,
                borderRadius: "4px",
                borderBottomLeftRadius: "0px",
                padding: "8px",
                minHeight: "165px",
              }}
            >
              <Grid container direction="column">
                {map(
                  get(data, [
                    "card6",
                    "assistance_required",
                    "assistance_top_reasons",
                  ]),
                  (v, k) => (
                    <Grid item key={k}>
                      <DashboardBar
                        title={I18n.get(`dashboard_${k}`)}
                        value={v}
                        percentage={
                          v /
                          get(data, ["card6", "assistance_required", "total"])
                        }
                        colors={[colors.dashboardDarkBlue, colors.greyDoughnut]}
                      />
                    </Grid>
                  )
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DashboardCard>
  );
};

export default withStyles(styles)(MdcAutomationEfficiency);
